import camelcaseKeys from "camelcase-keys";
import { useEffect, useState } from "react";
import { createContainer } from "unstated-next";
import { API_HOST } from "../config";
import history from "../history";
import { IUser } from "../interfaces";
import { checkAuthToken } from "../modules/auth";
import axios from "../modules/axiosInstance";
import { LoadingContainer } from "./LoadingContainer";

interface IUserList {
  users: IUser[];
  stage: "willMount" | "didMount";
  matchUsers: IUser[];
}

const useUserListContainer = () => {
  const loading = LoadingContainer.useContainer();
  const [users] = useState<IUser[]>([]);
  const [userList, setUserList] = useState<IUserList>({
    users,
    stage: "willMount",
    matchUsers: []
  });

  const fetchUsers = () => {
    loading.start();
    const url = window.location.search
      ? `${API_HOST}/api/users${window.location.search}`
      : `${API_HOST}/api/users`;
    axios
      .get(url)
      .then(results => {
        const data = results.data;
        const users = data.map((d: object[]) => {
          return camelcaseKeys(d);
        });
        setUserList({
          ...userList,
          users,
          stage: "didMount"
        });
        loading.done();
      })
      .catch(e => {
        loading.done();
        console.error(e);
        history.push("/login");
      });
  };
  // コンポーネントの描画前に "一度だけ" リクエストを送る。
  useEffect(() => {
    if (userList.stage === "willMount" && checkAuthToken()) {
      fetchUsers();
    }
  }, []);

  const changeMatchUsers = (matchUsers: IUser[]) => {
    setUserList({ ...userList, matchUsers });
  };

  return { userList, setUserList, changeMatchUsers, fetchUsers };
};

export const UserListContainer = createContainer(useUserListContainer);
